import React from 'react';
import SectionContainer from '../SectionContainer';
import CategoryPanel from '../../../LandingPage/CategoryPanel/CategoryPanel';

/**
 * Section component for the CategoryPanel
 * This allows the CategoryPanel to be used within the PageBuilder system
 * 
 * @component
 * @param {Object} props
 * @param {string} props.sectionId - ID of the section
 * @param {string} [props.className] - Custom class name
 * @param {string} [props.rootClassName] - Root class name override
 * @param {Array} [props.categories] - Array of categories to display
 * @param {Object} [props.appearance] - Appearance configuration
 * @param {Object} [props.options] - Additional options
 * @returns {JSX.Element} Section containing CategoryPanel
 */
const SectionCategory = props => {
  const {
    sectionId,
    className,
    rootClassName,
    categories,
    appearance,
    options,
    // Extract React-specific props that don't need to be passed down
    defaultClasses,
    isInsideContainer,
    sectionType,
    sectionName,
    // Any remaining props that might be valid DOM attributes
    ...domProps
  } = props;

  return (
    <SectionContainer
      id={sectionId}
      className={className}
      rootClassName={rootClassName}
      appearance={appearance}
      options={options}
      {...domProps}
    >
      <CategoryPanel
        categories={categories}
      />
    </SectionContainer>
  );
};

export default SectionCategory;
